
import React from 'react';
import { MapContainer, TileLayer, Marker, Popup} from 'react-leaflet';
import { Icon } from "leaflet";

// const importView = chartName =>
//   lazy(() =>
//     import(`./${chartName}`)
//       .catch(() => import(`./NullChart`))
//   );


function App(props) {

  var points = props.points;
  if (!points){
    points = [];
  }
  
  var width = props.width;
  var minLat = 99999999;
  var maxLat = -99999999;
  var minLong = 99999999;
  var maxLong = -99999999;

  var markers = points.map((aLocation, index)=>{

    var thisLat = aLocation.lat;
    var thisLong = aLocation.long;
    var position = [thisLat, thisLong];
    if (thisLat > maxLat){
      maxLat = thisLat;
    }
    if (thisLat < minLat){
      minLat = thisLat;
    }
    if (thisLong > maxLong){
      maxLong = thisLong;
    }
    if (thisLong < minLong){
      minLong = thisLong;
    }
    return <Marker position={position}>
          <Popup>{aLocation.name}<br/>{aLocation.details}
          </Popup>
        </Marker>
  })

  var widthMap = width * 0.9;
  if (width > 700){
    widthMap = 560;
  }

  var bounds = [
    [minLat, minLong],
    [maxLat, maxLong],]

  return <center>
      <link rel="stylesheet" href="https://unpkg.com/leaflet@1.2.0/dist/leaflet.css" />
      <script src="https://unpkg.com/leaflet@1.2.0/dist/leaflet.js"></script>
        <MapContainer bounds={bounds} style={{ width:widthMap, height: 600}}>
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {markers}
        </MapContainer>
    </center>         

}

export default App;
